import { render, staticRenderFns } from "./ManageRuleGroup.vue?vue&type=template&id=633930d0&"
import script from "./ManageRuleGroup.vue?vue&type=script&lang=js&"
export * from "./ManageRuleGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports